import { Button } from "@mui/material";
import {
  BOX_SHADOW_ALERT,
  BREAKPOINT_DESKTOP_XL,
} from "../constants/constants";
import { NotificationCard } from "components/SimpleComponents/TopBanner/NotificationCard";
import { Update } from "@mui/icons-material";
import { css } from "styled-components/macro";
import { blueButton } from "constants/colors";

const scale = (window.innerWidth / BREAKPOINT_DESKTOP_XL) * 0.8;
/** Popup toast message that says "Update is available! Update / Later"  */
export const UpdateIsAvailableIndicator = () => {
  return (
    <NotificationCard
      className="updateIsAvailableIndicator doNotPrint"
      {...{
        message: "An update is available!",
        icon: <TipsAndUpdatesIcon />,
        variant: "info",
        customCss: css`
          position: fixed;
          bottom: 12px;
          left: 12px;
          box-shadow: ${BOX_SHADOW_ALERT};
          height: fit-content;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          padding: 12px;
          font-size: 14px;
          && {
            margin: 0;
          }
          .icon-and-message {
            margin: auto;
          }
          button.MuiButton-root {
            text-transform: none;
            font-size: 16px;
            opacity: 1;
            transition: opacity 300ms ease;
            &:hover {
              opacity: 0.7;
            }
            &.btnUpdate {
              color: #fff;
              background-color: ${blueButton};
            }
            &.btnLater {
              color: #000;
              font-weight: bold;
            }
          }
          @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
            transform: scale(${scale});
            transform-origin: bottom left;
            padding: ${12 * scale}px;
            bottom: ${12 * scale}px;
            left: ${12 * scale}px;
            gap: ${12 * scale}px;
            font-size: ${14 * scale}px;
            button.MuiButton-root {
              font-size: ${16 * scale}px;
            }
            svg {
              width: ${24 * scale}px;
              height: ${24 * scale}px;
            }
          }
          display: none;
          &.show {
            display: flex;
          }
        `,
        ActionButton: (
          <div style={{ display: "flex", gap: 16 * Math.max(1, scale) }}>
            <Button
              className="btnLater"
              variant="text"
              onClick={() => {
                document
                  .querySelector(".updateIsAvailableIndicator")
                  ?.classList.remove("show");
              }}
            >
              Later
            </Button>
            <Button
              className="btnUpdate"
              variant="outlined"
              onClick={() => {
                window.location.reload();
              }}
              startIcon={<Update />}
            >
              Update
            </Button>
          </div>
        ),
      }}
    />
  );
};

function TipsAndUpdatesIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      {...props}
    >
      <rect fill="none" height="24" width="24" y="0" />
      <path d="M7,20h4c0,1.1-0.9,2-2,2S7,21.1,7,20z M5,19h8v-2H5V19z M16.5,9.5c0,3.82-2.66,5.86-3.77,6.5H5.27 C4.16,15.36,1.5,13.32,1.5,9.5C1.5,5.36,4.86,2,9,2S16.5,5.36,16.5,9.5z M21.37,7.37L20,8l1.37,0.63L22,10l0.63-1.37L24,8 l-1.37-0.63L22,6L21.37,7.37z M19,6l0.94-2.06L22,3l-2.06-0.94L19,0l-0.94,2.06L16,3l2.06,0.94L19,6z" />
    </svg>
  );
}
